// Decodes the year of birth from the PESEL prefix using the standard month-offset century encoding:
//   01–12 → 1900s, 21–32 → 2000s, 41–52 → 2100s, 61–72 → 2200s, 81–92 → 1800s.
export const extractYearOfBirthFromPesel = (pesel: string | undefined | null): number | null => {
  if (!pesel || pesel.length < 6) return null;
  const prefix = pesel.substring(0, 6);
  if (!/^\d{6}$/.test(prefix)) return null;

  const yy = Number(prefix.substring(0, 2));
  const mm = Number(prefix.substring(2, 4));

  if (mm >= 1 && mm <= 12) return 1900 + yy;
  if (mm >= 21 && mm <= 32) return 2000 + yy;
  if (mm >= 41 && mm <= 52) return 2100 + yy;
  if (mm >= 61 && mm <= 72) return 2200 + yy;
  if (mm >= 81 && mm <= 92) return 1800 + yy;
  return null;
};
